const shiftNames = {
  SHIFT_INVENTORY: 'shift_inventory',
  SHIFT_VTO: 'shift_vto',
};

export {
  shiftNames,
};
